import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import Image from '@plone/volto/components/theme/Image/Image';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import LogoImage from './Logo.svg';
import {
  getActiveLanguage,
  getLanguageHomePath,
} from '../../../../helpers/homepageUrl';

const messages = defineMessages({
  home: {
    id: 'Home',
    defaultMessage: 'Home',
  },
  logoOf: {
    id: 'Logo of',
    defaultMessage: 'Logo of',
  },
});

const Logo = () => {
  const site = useSelector((state) => state.site.data);
  const locale = useSelector((state) => state.intl.locale);
  const { pathname } = useLocation();
  const intl = useIntl();
  const language = getActiveLanguage(pathname, locale);
  const homePath = getLanguageHomePath(language);

  return (
    <Link to={homePath} aria-label={intl.formatMessage(messages.home)}>
      <Image
        className="ui image"
        src={
          site['plone.site_logo']
            ? flattenToAppURL(site['plone.site_logo'])
            : LogoImage
        }
        alt={
          intl.formatMessage(messages.logoOf) +
          ' ' +
          (site['plone.site_title'] || 'Clínica Sant Josep')
        }
      />
    </Link>
  );
};

export default Logo;
